export const getTableState = async () => {
  const response = await fetch("/users/deployments_table_state");
  const data = await response.json();
  return data;
};

export const saveTableState = async (key, value) => {
  try {
    await fetch("/users/save_deployments_table_state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token":
          document
            .querySelector('[name="csrf-token"]')
            ?.getAttribute("content") || "",
      },
      body: JSON.stringify({
        key: key,
        value: value,
      }),
    });
  } catch (error) {
    console.error("Error saving preferences:", error);
  }
};

export const resetTableState = async () => {
  await fetch("/users/reset_deployments_table_state", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":
        document
          .querySelector('[name="csrf-token"]')
          ?.getAttribute("content") || "",
    },
  });
};
